import { useEffect } from 'react';

import { boundActionsFactory } from '@/packages/redux-state/store';

const useBoundActions = boundActionsFactory(reduxActions => ({
  setIsPageReloading: reduxActions.browserPage.setIsPageReloading,
}));

export function usePopstate(): void {
  const boundActions = useBoundActions();

  useEffect(() => {
    const handler = (): void => {
      boundActions.setIsPageReloading(true);

      window.location.reload();
    };

    window.addEventListener('popstate', handler);

    return () => window.removeEventListener('popstate', handler);
  }, [boundActions]);
}
